// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6e69e8fa2b7b2b79","3196":"4891867bbe7dc3fc"}[chunkId] + ".css";
};